import clsx from "clsx";
import { type ReactNode, type HTMLAttributes, forwardRef } from "react";

import styles from "./collapsible.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
    isCollapsibleExpanded: boolean;
};

const Collapsible = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { children, className, isCollapsibleExpanded, ...otherProps } = props;

    return (
        <div
            {...otherProps}
            className={clsx(styles.collapsible, className)}
            ref={ref}
            data-expanded={isCollapsibleExpanded}
        >
            <div className={styles.collapsible_content}>{children}</div>
        </div>
    );
});

Collapsible.displayName = "Collapsible";

export { Collapsible };
export type { Props as CollapsibleProps };
